import { useEffect, useState } from 'react'
import { useNavigate, useParams } from "react-router-dom";
import css from './index.module.css';
import Content from '@components/adminNavigation';
import axios from "axios";
import * as Types from '../../../types';
import { toast } from 'sonner';
import SEO from '@components/seo';
import Tabs from './menu';

export default function User() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState<Types.User>();
  const [message, setMessage] = useState('');
  
  const [title, setTitle] = useState('');
  const [notificationMessage, setNotificationMessage] = useState('');

  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    axios.get(`${import.meta.env.VITE_API_ADM_URL}/user/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    }).then(response => {
        setUser(response.data);
    }).catch(error => {
      console.log(error);
    });
  }, []);

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    setUser((prev) => {
      if (!prev) return prev;

      const keys = name.split('[').map((key: any) => key.replace(']', ''));

      if (keys.length === 1) {
        return {
          ...prev,
          [keys[0]]: value,
        };
      }

      if (keys.length === 2) {
        return {
          ...prev,
          [keys[0]]: {
            ...prev[keys[0] as keyof typeof prev],
            [keys[1]]: value,
          },
        };
      }

      return prev;
    });
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();

    axios.post(`${import.meta.env.VITE_API_ADM_URL}/user/${id}`, user, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
    })
    .then(_ => {
      toast.success('Информация обновлена')
    })
    .catch(error => {
      console.log(error);
      toast.error('Ошибка');
    });
  };

  const handleSendMessage = (event: any) => {
    event.preventDefault();

    axios.post(`${import.meta.env.VITE_API_ADM_URL}/user/${id}/sendMessage`, { message: message }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    })
    .then(_ => {
      toast.success('Сообщение отправлено')
      setMessage('');
    })
    .catch(error => {
      console.log(error);
      toast.error('Ошибка отправки сообщения');
    });
  };

  const handleSendNotification = (event: any) => {
    event.preventDefault();

    axios.post(`${import.meta.env.VITE_API_ADM_URL}/user/${id}/sendNotification`, { title: title, body: notificationMessage }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    })
    .then(_ => {
      toast.success('Уведомление отправлено')
      setTitle('');
      setNotificationMessage('');
    })
    .catch(error => {
      console.log(error);
      toast.error('Ошибка отправки уведомления');
    });
  };

  return (
    <Content>
      <SEO 
        title={'Управление пользователем'}
        description={'Админ-панель'}
        ogUrl={`https://рыбныимир.рф`}
      />

      <h1 className={css.head}>{user?.phone}</h1>
      <Tabs active={activeTab} setActive={setActiveTab} />

      {activeTab === 0 && (
      <form onSubmit={handleSubmit}>
        <b className={css.headAcc}>Личные данные</b>

        <div className={css.inputGrid}>
          <label>Имя</label>
          <input name='firstName' type='text' placeholder='Имя' value={user?.firstName} onChange={handleChange} />
        </div>

        <div className={css.inputGrid}>
          <label>Фамилия</label>
          <input name='lastName' type='text' placeholder='Фамилия' value={user?.lastName} onChange={handleChange} />
        </div>

        <div className={css.inputGrid}>
          <label>Логин</label>
          <input name='username' type='text' placeholder='Логин' value={user?.username} onChange={handleChange} />
        </div>

        <div className={css.inputGrid}>
          <label>Номер телефона (Формат: +79990000001)</label>
          <input name='phone' type='text' placeholder='Номер телефона' value={user?.phone} onChange={handleChange} required />
        </div>

        <div className={css.inputGrid}>
          <label>Уровень доступа</label>
          <select name='access' value={user?.access} onChange={handleChange}>
              <option value={1}>Администратор</option>
              <option value={0}>Пользователь</option>
          </select>
        </div>

        <b className={css.headAcc}>Административные данные</b>

        <div className={css.inputGrid}>
          <label>Комментарий администратора</label>
          <textarea name='adminComment' placeholder='Заметки' style={{ height: 100 }} onChange={handleChange} value={user?.adminComment} />
        </div>

        <div className={css.inputGrid}>
          <label>Дата создания аккаунта</label>
          <a style={{ flex: 3.05 }}>{new Date(user?.createdAt || '').toLocaleDateString() || 'Не указано'}</a>
        </div>
        
        <div className={css.inputGrid}>
          <label>Дата последнего обновления аккаунта</label>
          <a style={{ flex: 3.05 }}>{new Date(user?.updatedAt || '').toLocaleDateString() || 'Не указано'}</a>
        </div>
        
        <button className={css.saveBtn} type='submit'>Сохранить изменения</button>
      </form>
      )}
      
      {activeTab === 1 && (
        <div>
          <div className={css.sendMessageContainer}>
            <b>Отправить сообщение в чат</b>
            <textarea name='message' placeholder='Сообщение' value={message} onChange={(e) => setMessage(e.target.value)} />
            <button className={css.sendMessageBtn} type='button' onClick={handleSendMessage}>Отправить сообщение</button>
          </div>

          <div className={css.sendMessageContainer} style={{ marginTop: 20, borderTop: '1px solid #0000001e', paddingTop: 20 }}>
            <b>Отправить персональное уведомление</b>
            <input name='title' type='text' placeholder='Заголовок' value={title} onChange={(e) => setTitle(e.target.value)} />
            <textarea name='notificationMessage' placeholder='Сообщение' value={notificationMessage} onChange={(e) => setNotificationMessage(e.target.value)} />
            <button className={css.sendMessageBtn} type='button' onClick={handleSendNotification}>Отправить сообщение</button>
          </div>
        </div>
      )}
      {activeTab === 2 && (
        <div className={css.organizationsContainer}>
          {user?.organizations && user?.organizations.length > 0 ? (
            <div className={css.organizationsList}>
              {user?.organizations.map((organization) => (
                <div className={css.organizationItem} onClick={() => navigate(`/manage/organization/${organization.orgId}`)}>
                  <a>{organization.name}</a>
                  <span>{organization.address}</span>
                </div>
              ))}
            </div>
          ) : (
            <div className={css.organizationsEmpty}>
              <a>Организаций нет</a>
            </div>
          )}
        </div>
      )}
    </Content>
  );
}
